

import { ReactElement } from 'react';
import { Shape, Line } from '../../../context/context';
import { getResolvedMissionControlPoint } from '../../map/functions/missionControlTripStyles';

import { Icon } from '@liftango/ui-icons';
import { ICON_FALLBACKS } from '../../../utils/iconFallbacks';
// 1. Icon mapping dictionary — maps marker type to ICON_FALLBACKS SVG path key
const iconMapping: Record<string, string> = {
  default: ICON_FALLBACKS.PlaceOutlined,
  star: ICON_FALLBACKS.StarOutlined,
  location: ICON_FALLBACKS.LocationOnOutlined,
  dot: ICON_FALLBACKS.FiberManualRecordOutlined,
  flag: ICON_FALLBACKS.FlagOutlined,
  hospital: ICON_FALLBACKS.LocalHospitalOutlined,
  school: ICON_FALLBACKS.SchoolOutlined,
  shopping: ICON_FALLBACKS.ShoppingCartOutlined,
  airport: ICON_FALLBACKS.FlightOutlined,
  bus: ICON_FALLBACKS.DirectionsBusOutlined,
  train: ICON_FALLBACKS.TrainOutlined,
  tram: ICON_FALLBACKS.TramOutlined,
  subway: ICON_FALLBACKS.SubwayOutlined,
  store: ICON_FALLBACKS.StoreOutlined,
  restaurant: ICON_FALLBACKS.RestaurantOutlined,
  parking: ICON_FALLBACKS.LocalParkingOutlined,
  library: ICON_FALLBACKS.LocalLibraryOutlined,
  playground: ICON_FALLBACKS.SportsSoccer,
};

export default function markerType(
  shape: Shape,
  isSelected: boolean,
  options?: { isTripPointLinked?: boolean; allowColorFallback?: boolean }
) {
    if (shape.type === 'point') {
        const resolved = getResolvedMissionControlPoint(
          shape,
          options?.isTripPointLinked ?? false,
          options?.allowColorFallback ?? true
        );

        const iconColor = resolved.color || (isSelected ? 'blue' : 'inherit');

        // Use iconMapping instead of switch
        const iconPath = iconMapping[resolved.icon] || ICON_FALLBACKS.PlaceOutlined;
        return <Icon size={20} d={iconPath} style={{ marginRight: 8, color: iconColor }} />;
    } else if (shape.type === 'polygon') {
        return <Icon size={20} d={ICON_FALLBACKS.PentagonOutlined} style={{ marginRight: 8, color: isSelected ? 'blue' : 'inherit' }} />;
    } else if (shape.type === 'line') {
        const line = shape as Line;
        
        // Check if this is a fixed route line
        const metadata = (line as any).fixedRouteMetadata;
        const isFixedRoute = metadata && metadata.type === 'fixedRoute';
        
        // Determine icon color: use route color for fixed routes, otherwise use selection color or inherit
        let iconColor: string;
        if (isFixedRoute && line.colour) {
            // Use the route's color for fixed routes
            iconColor = line.colour;
        } else {
            // For regular lines, use blue if selected, otherwise inherit (black)
            iconColor = isSelected ? 'blue' : 'inherit';
        }
        
        // Show RouteOutlinedIcon for fixed routes and trip lines, ShowChartOutlinedIcon for normal lines
        if (isFixedRoute || ('originPointId' in shape && 'destPointId' in shape && shape.originPointId && shape.destPointId)) {
            return <Icon size={20} name="route" style={{ marginRight: 8, color: iconColor }} />;
        }
        return <Icon size={20} d={ICON_FALLBACKS.ShowChartOutlined} style={{ marginRight: 8, color: iconColor }} />;
    }
    return null;
}

